<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                      <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                      <div class="flex-1">
                        <h3 class="m-0">History Saldo</h3>
                        <p class="mb-0">Semua Alur Saldo anda disini ya</p>
                      </div>
                    </div>
                    <div class="card mb-2">
                      <div class="card-body">
                          <div class="bulan-box">
                            <span>Pilih Bulan dan Tahun</span>
                            <div class="box-horizontal">
                              <span class="h4 mr-2 text-info pointer" v-text="myGlobal.getBulanNow()"></span>
                              <span class="h4 text-info pointer" v-text="myGlobal.getTahunNow()"></span>
                            </div>
                          </div>
                          <div class="table-responsive">
                          <table class="table">
                              <thead class="">
                                <th>Tanggal</th>
                                <th>Nama Pelanggan</th>
                                <th>Jumlah</th>
                                <th>Sisa</th>
                              </thead>
                              <!-- LOADING -->
                              <tbody v-show="dataAll.loading">
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              </tbody>
                              <!-- DATA -->
                              <tbody v-show="!dataAll.loading">
                              <tr v-for="(u, index) in theGet.data.List">
                                  <td>
                                    <span class="d-block">{{u.jam}}</span>
                                    <span class="d-block">{{myGlobal.tglIndo(u.tanggal)}}</span>
                                  </td>
                                  <td v-if="u.h_id != null"> 
                                    <strong>#{{u.h_id}}</strong>
                                    <span class="d-block">{{u.unama}}</span>
                                    <span class="d-block">{{u.uwa}}</span>
                                    <span class="d-block">{{u.uarea}}</span>
                                  </td>
                                  <td v-else>
                                    <strong class="text-success">Withdraw {{myGlobal.tglIndo(u.tanggal)}}</strong>
                                  </td>
                                  <td>
                                    <span v-if="u.keterangan == 'keluar'" class="text-danger">-{{ myGlobal.ribu(u.jumlah) }}</span>
                                    <span v-else class="text-success">+{{ myGlobal.ribu(u.jumlah) }}</span>
                                    
                                  </td>
                                  <td>
                                      <div>
                                        <span class="d-block">{{ myGlobal.ribu(u.saldo_after) }}</span>
                                      </div>
                                  </td>
                                  <td v-show="false">
                                    <button class="btn btn-sm btn-primary" @click="theGet.rincian(u)">Rincian</button>
                                  </td>
                              </tr>
                              <!-- NULL -->
                              <tr v-if="theGet.data.List == null">
                                  <td></td>
                                  <td>Tidak ada Data </td>
                              </tr>
                              </tbody>
                          </table>
                          </div>
                      </div>
                      <div class="card-footer text-center" v-show="dataAll.page != 999">
                        <button class="btn btn-info" @click="theGet.loadmore()">Loadmore</button>
                      </div>
                    </div>
                </div>
                
            </div>
        </div>

      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
	components: { 
      "Loading" : Loading
	}, 
  setup() {
    const dataAll = reactive({
      loading: true,
      bulan: '0',
      tahun: '0',
      saldo: "0",
      saldoPending: "0",
      page: 0
    })

    const theGet = {
      data: reactive({
        List: [],
      }),
      HistorySaldo() {
        var datax = {
          token: 'TangTung '+myGlobal.Session('token'),
          tahun: dataAll.tahun,
          bulan: dataAll.bulan,
          page: dataAll.page
        };
    
        var apiUrl = inter.HistorySaldo();
        myGlobal.call(datax,apiUrl).then(x => {
          
          // console.log(JSON.stringify(x));

          dataAll.loading = false;

          if (x.status == true) {
            if (this.data.List.length > 0) {
              // loadmore
              var i;
              for (i = 0; i < x.data.length; i++) {
                this.data.List.push(x.data[i]);
              }
            } else {
              // new
              this.data.List = x.data;
            }
          } else {
            if (dataAll.page == 0) {
              theGet.data.List = null;
            } else {
              dataAll.page = 999;
            }
          }

        })
      },
      loadmore() {
        if (dataAll.page != 999) {
          dataAll.page = dataAll.page + 1;
          theGet.HistorySaldo();
        } else {
          alert("Ini data akhir maseh :)");
        }
      }
    }

    return {
      dataAll,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Invoice";

    this.dataAll.namaQ = sessionStorage.getItem('admin');

    this.dataAll.bulan = myGlobal.getBulan();
    this.dataAll.tahun = myGlobal.getTahunNow();
    
    this.theGet.HistorySaldo();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
  display: inherit;
}
.box-menu {
    padding: 15px;
}
.box-menu > i {
    font-size: 25pt;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/history-saldo.vue